import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WalletHistoryRow = _resolveComponent("WalletHistoryRow")!
  const _component_WalletCard = _resolveComponent("WalletCard")!

  return (_openBlock(), _createBlock(_component_WalletCard, {
    class: _normalizeClass(_ctx.b()),
    title: "Последние операции",
    tab: "deposit-withdrawal"
  }, {
    default: _withCtx(() => [
      (_ctx.displayedHistory.length)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_ctx.b('table'))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.b('rows'))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedHistory, (row) => {
                return (_openBlock(), _createBlock(_component_WalletHistoryRow, {
                  class: _normalizeClass(_ctx.b('row')),
                  key: row.id,
                  row: row
                }, null, 8, ["class", "row"]))
              }), 128))
            ], 2)
          ], 2))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(_ctx.b('empty'))
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.b('empty-icon'))
            }, "↓", 2),
            _createElementVNode("h5", {
              class: _normalizeClass(_ctx.b('empty-title'))
            }, _toDisplayString(_ctx.$t("Пока нет операций")), 3),
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.b('empty-text'))
            }, _toDisplayString(_ctx.$t("Пополнения и выводы появятся здесь после первой операции")), 3),
            _createElementVNode("button", {
              class: _normalizeClass(_ctx.b('empty-cta')),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('deposit')))
            }, _toDisplayString(_ctx.$t("Пополнить")), 3)
          ], 2))
    ]),
    _: 1
  }, 8, ["class"]))
}